<template>

  <v-base-card>
    <template v-slot:heading>
      登録・申込フォーム 確認
    </template>
    <template v-slot:content>
      <!-- 塾情報フォーム -->
      <v-request-customer-form isConfirm/>

      <!-- 登録済教室一覧 -->
      <v-registered-classroom-table v-if="!isNewCustomer" isConfirm/>

      <!-- 教室情報フォーム -->
      <template v-for="index in classrooms.length">
        <v-request-classroom-form
          v-if="!isCancelClassroom"
          :key="index"
          :index="index"
          isConfirm
        />
      </template>


      <div class="mt-8 confirm__area" v-if="isCancelClassroom">
        <v-cancel-form class="ml-3" isConfirm/>
      </div>

      <!-- ボタンら -->
      <v-spacer/>
      <v-btn class="mt-6 confirm__btn" to="/enrollment/new">申込フォームに戻る</v-btn>
      <v-btn class="mt-6 float-right confirm__btn" @click="submit">申込を確定する</v-btn>
    </template>
  </v-base-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import enrollmentMixin from "@/mixins/enrollment";
import VRegisteredClassroomTable from '@/components/molecules/RegisteredClassroomTable'
import VRequestCustomerForm from '@/components/organizms/RequestCustomerForm'
import VRequestClassroomForm from '@/components/organizms/RequestClassroomForm'
import VCancelForm from '@/components/organizms/CancelForm'
import VBaseCard from '@/components/molecules/BaseCard'

export default {
  mixins: [enrollmentMixin],
  components: {
    VBaseCard,
    VRegisteredClassroomTable,
    VRequestCustomerForm,
    VRequestClassroomForm,
    VCancelForm
  },

  watch: {},

  mounted() {
  },

  computed: {
    ...mapState('enrollment', [
      'classrooms',
    ]),
    ...mapGetters('enrollment', [
      'isNewCustomer',
      'isCancelClassroom'
    ])
  },

  methods: {
    async submit() {
      const params = await this.$store.dispatch('enrollment/generateApiParams')
      const url = this.$store.getters['enrollment/apiUrl']
      await this.$axios.post(url, params)
      this.$router.push("/enrollment/result")
    }
  }
}
</script>

<style lang="stylus">
.v-input__slot
  min-height 10px !important
  margin-bottom 0px !important
.v-text-field__details
  background-color #fff1f8 !important
  margin-bottom 0px !important
  padding 4px 3px !important

</style>

<style lang="stylus" scoped>

th
  width 30%
  height 30px
  background-color #3b7cab
  text-align left
  color #fff
  font-size 14px
  vertical-align top
  padding 9px
  border-bottom 1px solid #ddd

td
  width 1500px
  background-color #fff1f8
  border 1px solid white

.text-field
  width 200px
  margin 10px
  min-height 10px
  background-color white
  &__file
    width 400px
    margin 10px
    min-height 10px


.attention
  font-size 12px
  margin-bottom 5px

.hint
  font-size 11px
  color #252525
  margin-bottom 5px

.address
  &__area
    height 25px
  &__mark
    display inline-block
    font-size 14px

.input__address
  color #a8a8a8
  display inline-block
  border 1px solid #a8a8a8
  border-radius 4px
  background-color white
  width 100px
  padding 0px 4px

.confirm__btn
  background-color #D65B5B !important
  border-color #D05353 !important
  color white

</style>
